import React from 'react';
import XLSX from 'xlsx';

import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Button from '../../components/buttons/Button';
import PrintPdf from '../../utils/print/PrintPdf';
import SelectAjax from "../../components/form/SelectAjax";
import Modal from '../../components/modal/Modal';
import Page from './Page';
import TextInput from '../../components/form/TextInput';
import PageCliente from './PageCliente';
import {FormDataToJson} from '../../utils/json/Json';

const URL_DETALHE_ITEM = WS.clientes.detalhe;
const URL_LISTA = WS.relatorios.clientes;
const URL_LISTA_CLIENTES = WS.clientes.lista;
//
class RelatoriosGeral extends React.Component{
  constructor (props){
    super(props);

    const date = new Date();
    let firstDay = 1 +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();
    let today = date.getDate() +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: false,
      data: [],
      ativo: false,
      inativo: false,
      teste: false,
      teste_expirado: false,
      boleto: false,
      cartao: false,
      primeiro_pagamento: false,
      cancelamentos: false,
      cadastrados: false,
      sexo: '',
      plano: '',
      dataInicial: firstDay,
      dataFinal: today
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.printDiv = this.printDiv.bind(this);
    this.creatExcel = this.creatExcel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.callQuestion = this.callQuestion.bind(this);
    this.verPagamentos = this.verPagamentos.bind(this);
    this.searchClienteHandler = this.searchClienteHandler.bind(this);
    this.searchClientes = this.searchClientes.bind(this);
  }

  searchClientes(e) {
    e.preventDefault();
    this.setState({
      searchStatus: !this.state.searchStatus
    });
  }

  searchClienteHandler(e){
    e.preventDefault();

    const formData = new FormData(e.target);
    var object = FormDataToJson(formData);

    const {atencao} = this.state.strings;
    let _self = this;

    //e.target.reset();
    const history = this.props.history;

    Requisitions({
      url:URL_LISTA_CLIENTES,
      data:object,
      sucess:function(data){
        var msg;

        if(data.status){
          var modal = new Modal();
          modal.open({page:<PageCliente modal={modal} detalhe={data} history={history} />});
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  verPagamentos(e){
    const target = e.target;
    const id = target.getAttribute('data-id');
    const {atencao,erroDetalhe} = this.state.strings;

    const history = this.props.history;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;

        if(data.status){
          var modal = new Modal();
          modal.open({page:<Page modal={modal} detalhe={data.item} history={history} />});
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  handleSelectChange (value) {
    this.setState({
      plano: value.value
    });
  }

  callQuestion(text){
    alert(text);
    return false;
  }

  handleInputChange(event) {
   const target = event.target;
   const value = target.type === 'checkbox' ? target.checked : target.value;
   const name = target.name;

   this.setState({
     [name]: value
   });
 }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    //this.loadData({});
  }

  loadData(_args_) {
    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: _self.props.url,
      data:_args_,
      sucess:function(data){
        _self.setState({
          lista: data.items,
          isLoading: false,
          dataInicial: _args_.dti,
          dataFinal: _args_.dtf
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  handleSubmit(e){
    const form = document.getElementById('form-data-adesao');
    const dti = form.querySelectorAll("[name='dti']")[0].value;
    const dtf = form.querySelectorAll("[name='dtf']")[0].value;
    const ativo = this.state.ativo;
    const inativo = this.state.inativo;
    const boleto = this.state.boleto;
    const cartao = this.state.cartao;
    const cancelamentos = this.state.cancelamentos;
    const cadastrados = this.state.cadastrados;
    const primeiro_pagamento = this.state.primeiro_pagamento;
    const plano = this.state.plano;
    const teste = this.state.teste;
    const teste_expirado = this.state.teste_expirado;
    const sexo = this.state.sexo;
    const data = {plano, teste, teste_expirado, sexo, dti, dtf, ativo, inativo, boleto, cartao, cancelamentos, cadastrados, primeiro_pagamento};

    this.loadData(data);

    e.preventDefault();
  }

  getArrayExcel(){
    const arr = [];
    arr.push(["Nome", "E-mail", "Cpf", "Tipo de adesão", "Data do cadastro", "Data do pagamento", "Parcelas", "Plano", "Valor"]);
    let lista = this.state.lista.map((value, i) => {
      arr.push([
        value.name,
        value.email,
        value.cpf_cnpj,
        (value.tipo_adesao === "B" ? "Boleto" : "Cartão"),
        value.data_cadastro,
        value.data_pg,
        value.parcelas,
        value.plano,
        value.valor
      ]);
    });
    return arr;
  }

  creatExcel(e){
    e.preventDefault();
    const arr = this.getArrayExcel();
    const ws = XLSX.utils.aoa_to_sheet(arr);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, "foco90.xlsx");
  }

  printDiv(e){
    e.preventDefault();
    var sWinHTML = document.getElementById('printable').innerHTML;
    PrintPdf.print(sWinHTML);
    return false;
  }

  resultSearch(){
    let lista = this.state.lista.map((value, i) =>
      <div className='item-relatorio' key={i}>
          <div className='item-relatorio__title'>{value.name} <a className='button-ver-pagamentos' href="#" data-id={value.id} onClick={this.verPagamentos}>Ver pagamentos</a><div className='clear'></div></div>
          <div>E-mail: {value.email}</div>
          <div>Cpf: {value.cpf_cnpj}</div>
          {(() => {
            if(value.tipo_adesao){
              return <div>Pagamento: {value.tipo_adesao === 'B' ? 'Boleto' : 'Cartão'}</div>;
            }
          })()}

          {(() => {
            if(value.data_cadastro){
              const dataCadastro = value.data_cadastro.split('-').join('/');
              return <div>Data do cadastro: {dataCadastro}</div>;
            }
          })()}
          {(() => {
            if(value.parcelas){
              return <div>Nº de parcelas: {value.parcelas}</div>;
            }
          })()}
          {(() => {
            if(value.plano){
              return <div>Plano: {value.plano} ({value.valor})</div>;
            }
          })()}
          {(() => {
            if(value.data_pg && value.data_pg.length>5){
              const datapag = value.data_pg.split('-').join('/');
              return <div>Data do pagamento: {datapag}</div>;
            }
          })()}
          {(() => {
            if(value.tid){
              return <div>Tid: {value.tid}</div>;
            }
          })()}
      </div>
      );

    if(lista.length<=0){
      lista = <EmptyList />;
    }

    let result = (
      <div>
        <div className="box-bt-export">
          <div className="pure-u-g">
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.printDiv}>Gerar pdf</a></div>
            </div>
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.creatExcel}>Gerar excel</a></div>
            </div>
          </div>
          <br /><br />
        </div>
        <div id="printable">
          <div className='title-relatorio'>{this.state.lista.length} {this.props.title}</div>
          {lista}
        </div>
      </div>
    );

    return result;
  }


  render() {
    const strings = this.state.strings;

    const { dataInicio, dataFim, procurar } = this.state.strings;
    const result = this.state.isLoading ? <LoadingPage /> : this.resultSearch();

    var date = new Date();
    var timestamp = date.getTime();

    const searchStatus = this.state.searchStatus ? 'ativo' : '';


    return (
      <div>
        <div>
          <div className=''>
            <form onSubmit={this.handleSubmit} id="form-data-adesao" className='form-relatorio'>
              <div>
                <span className='title-relatorios'>Clientes</span>
              </div>
              <div className='box-relatorio-checks'>
                <div className="pure-u-8-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="teste" checked={this.state.teste} onChange={this.handleInputChange} />
                    <span>{strings.clientesEmTeste}
                      <a className='bt-information' href='#' onClick={(e) => {this.callQuestion('Clientes que baixaram o app, estão usando o período gratuito e não expirou, ou seja, ainda podem acessar o app');e.preventDefault();}} >
                        <i className="far fa-question-circle"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <div className="pure-u-8-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="ativo" checked={this.state.ativo} onChange={this.handleInputChange} />
                    <span>{strings.clientesPagantes}
                      <a className='bt-information' href='#' onClick={(e) => {this.callQuestion('Clientes ativos que aderiram a um plano');e.preventDefault();}} >
                        <i className="far fa-question-circle"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <div className="pure-u-8-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="inativo" checked={this.state.inativo} onChange={this.handleInputChange} />
                    <span>{strings.clientesInativos}
                      <a className='bt-information' href='#' onClick={(e) => {this.callQuestion('Clientes que não tem validade, ou seja, a data de validade do plano expirou e ele não pagou');e.preventDefault();}} >
                        <i className="far fa-question-circle"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <div className="pure-u-24-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="teste_expirado" checked={this.state.teste_expirado} onChange={this.handleInputChange} />
                    <span>{strings.clientesTestaramNaoPagaram}
                      <a className='bt-information' href='#' onClick={(e) => {this.callQuestion('Todos os clientes que usaram o período gratuito, expirou e não pagaram. Ou seja, não acessam mais o app');e.preventDefault();}} >
                        <i className="far fa-question-circle"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <span className='title-relatorios'>Tipos de adesões</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="boleto" checked={this.state.boleto} onChange={this.handleInputChange} />
                    <span>{strings.adesoesBoleto}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="cartao" checked={this.state.cartao} onChange={this.handleInputChange} />
                    <span>{strings.adesoesCartao}</span>
                  </div>
                </div>
              </div>

              <div>
                <span className='title-relatorios'>Data a considerar</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="cancelamentos" checked={this.state.cancelamentos} onChange={this.handleInputChange} />
                    <span>{strings.cancelamentos}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="cadastrados" checked={this.state.cadastrados} onChange={this.handleInputChange} />
                    <span>{strings.cadastrados}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="primeiro_pagamento" checked={this.state.primeiro_pagamento} onChange={this.handleInputChange} />
                    <span>{strings.primeiro_pagamento}</span>
                  </div>
                </div>
              </div>


              <div>
                <span className='title-relatorios'>Sexo</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="radio" name="sexo" value="F" checked={(this.state.sexo === 'F')} onChange={this.handleInputChange} />
                    <span>{strings.feminino}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="radio" name="sexo" value="M" checked={(this.state.sexo === 'M')} onChange={this.handleInputChange} />
                    <span>{strings.masculino}</span>
                  </div>
                </div>

              </div>

              <div>
                <span className='title-relatorios'>{strings.titlePlanos}</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-12-24">
                  <SelectAjax  url={WS.planos.autocomplete} onChange={this.handleSelectChange}  title={strings.selecionePlano} />
                </div>
              </div>

              <div className="pure-u-9-24">
                <DateRangePickerWrapper
                  key={timestamp}
                    dti={this.state.dataInicial}
                    dtf={this.state.dataFinal}
                   titleDateInicio={dataInicio}
                   titleDateFim={dataFim} />
              </div>
              <div className="pure-u-9-24">
                <div className='box-button-search-date'><Button type="submit" text={procurar} classes="bt-save bt-blue" /></div>
              </div>
              <br /><br />
            </form>

            <div><a href="#" onClick={this.searchClientes} class="bt-search"><i class="fas fa-search"></i><span>   Buscar pagamentos de cliente</span></a></div>

            <div className={`${searchStatus} form-search`}>
            <br /><br />
              <form onSubmit={this.searchClienteHandler}>
                <div className='pure-u-6-24'>
                  <TextInput
                    onChange={this.handleInputChange}
                    name="nome"
                    title={strings.txtNome}
                    placeholder={strings.digiteAqui}>
                  </TextInput>
                </div>
                <div className='pure-u-6-24'>
                  <TextInput
                    onChange={this.handleInputChange}
                    name="email"
                    title={strings.txtEmailCadastro}
                    placeholder={strings.digiteAqui}>
                  </TextInput>
                </div>
                <div className='pure-u-6-24'>
                  <TextInput
                    onChange={this.handleInputChange}
                    name="cpf_cnpj"
                    title={strings.txtCpf}
                    placeholder={strings.digiteAqui}>
                  </TextInput>
                </div>
                <br />
                <div className="separador"></div>
                <br />
                <div className="box-right-button"><Button type="submit" text={strings.buscar} classes="bt-save bt-blue" /></div>
              </form>
            </div>
            <br /><br />
          </div>
        </div>
        {result}
      </div>
    );
  }
}

export default RelatoriosGeral;



// WEBPACK FOOTER //
// ./src/classes/relatorios/RelatoriosGeral.js